import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { getRoomInfo, RoomInfoDto, RoomInfoRoomRequest } from 'src/api/roomService';
import { StayLength } from 'src/shared/types/stay-length';

import { queryRetry } from '../query-retry';

type UseFetchRoomInfoOptions = RoomInfoRoomRequest & {
    stay: StayLength | null;
    enabled?: boolean;
};

export const useFetchRoomInfo = ({ stay, enabled = true, ...room }: UseFetchRoomInfoOptions) =>
    useQuery<RoomInfoDto, AxiosError>({
        enabled: enabled && Boolean(room.roomCode && room.academicYear && room.moveInDate && stay),
        queryKey: [
            'roomInfo',
            room.developmentSlug,
            room.roomCode,
            room.academicYear,
            room.moveInDate,
            stay?.duration,
            stay?.moveOutDate,
        ],
        // Only enabled with a stay
        queryFn: () => getRoomInfo({ ...room, ...stay! }),
        retry: queryRetry,
        staleTime: Infinity,
    });
